import { render } from "./FormsPage.vue?vue&type=template&id=3e0362ea&scoped=true"
import script from "./FormsPage.vue?vue&type=script&lang=js"
export * from "./FormsPage.vue?vue&type=script&lang=js"

import "./FormsPage.vue?vue&type=style&index=0&id=3e0362ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0362ea"]])

export default __exports__